import React, { Suspense } from 'react';
import { SearchErrorBoundary } from '../search/search-error-boundary';
import { ConversationModal } from './conversation-modal';

export const Conversation = () => {
    return (
        <SearchErrorBoundary id="search">
            <Suspense fallback={null}>
                <ConversationModal />
            </Suspense>
        </SearchErrorBoundary>
    );
};

export default Conversation;
